module.exports = __webpack_public_path__ + "fi.svg?dab559535c473cde1920bcc1925728e4";